import { Loading, TitleActionButton } from '@organization/components'
import { useSessionContext } from '@shared/hooks'
import { Flex } from 'antd'
import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { ApplicationList, ApplicationModal } from '../components'

export const ApplicationPage = () => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [search, setSearch] = useState('')

  const { t } = useTranslation()
  const { user, isLoading } = useSessionContext()

  const onToggle = () => setIsOpenModal((prev) => !prev)

  if (isLoading) {
    return <Loading />
  }

  return (
    <Flex vertical gap={16}>
      <ApplicationModal isOpen={isOpenModal} onCloseModal={onToggle} />

      <TitleActionButton
        title={`${t('application.header')} (${
          user?.pinned_applications?.length ?? 0
        })`}
        searchValue={search}
        onSearch={setSearch}
      />

      <ApplicationList
        applicationList={user?.pinned_applications}
        onOpenModal={onToggle}
      />
    </Flex>
  )
}
